// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"669":"7216c6a9","787":"3645fdb3"}[chunkId] + ".chunk.js";
};